import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  selectModalName,
  selectModalIsOpen,
  selectModalProps,
} from '../../store/selectors';
import { closeModal } from '../../store/actions/modal';

const propTypes = {
  modalName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  modalProps: PropTypes.object,
};

const defaultProps = {
  modalProps: {},
};

export class ModalController extends React.Component {
  constructor(props) {
    super(props);
    this.appRoot = document.getElementById('root');
    this.modelRoot = document.createElement('div');
  }

  componentDidMount() {
    this.appRoot.appendChild(this.modelRoot);
  }

  componentWillUnmount() {
    this.appRoot.removeChild(this.modelRoot);
  }

  createModal = () => {
    const { modalName, children, onClose, isOpen, modalProps } = this.props;

    if (!React.Children.count(children)) return null;

    const modals = React.Children.map(children, child => {
      if (child.type.displayName !== modalName) return;

      // this is used to handle the scenario where we need to add the same modal to each
      // item in a slider or carousel.
      if (
        child.props.modalIndex !== undefined &&
        modalProps.modalIndex !== undefined &&
        child.props.modalIndex !== modalProps.modalIndex
      )
        return;

      // eslint-disable-next-line consistent-return
      return React.cloneElement(child, {
        onClose,
        isOpen,
        ...modalProps,
      });
    });

    return modals[0];
  };

  render() {
    return ReactDOM.createPortal(this.createModal(), this.modelRoot);
  }
}

ModalController.propTypes = propTypes;
ModalController.defaultProps = defaultProps;

const mapStateToProps = createStructuredSelector({
  modalName: selectModalName(),
  isOpen: selectModalIsOpen(),
  modalProps: selectModalProps(),
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalController);
